import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const promocodeListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}promo-code?search=${payload?.keyword || ''}&sort_order=${payload?.sort}&paginate=${payload?.page}&size=${payload?.length || ''}&sort=${payload?.sort_by || ''}&filter[status]=${payload?.status === "all" ? "" : payload?.status}&filter[is_percentage]=${payload?.discount_type === "all" ? "" : payload?.discount_type}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const promocodeDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}promo-code/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const addPromocodeApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}promo-code`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const updatePromocodeApi = async (payload) => {
    const request = requestAuthOption("PUT", payload?.promocode)
    try {
        const response = await fetch(
            `${server}promo-code/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const deletePromocodeApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(
            `${server}promo-code/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportPromocodeApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}promo-code/export`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};
